import React from "react"
import clsx from "clsx"
import Select2MultiSelect from "../../Selects/Select2MultiSelect"

class SuperAdminAmenityBuilderRUAmenities extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'ru-amenities',
      'tab-pane': true,
    })
    return(
      <div className={tabClasses} id="ru-amenities">
        <Select2MultiSelect
          values={this.props.amenity.ru_amenities}
          name="amenities"
          onChange={this.props.onChangeRUAmenities}
          className="form-control filter-select-input col-xs-9 col-sm-9 col-md-9"
          options={this.props.all_ru_amenities}/>
      </div>
    )
  }
}

export default SuperAdminAmenityBuilderRUAmenities